import { render, staticRenderFns } from "./ContentInformacao.vue?vue&type=template&id=5f6d7034"
import script from "./ContentInformacao.vue?vue&type=script&lang=js"
export * from "./ContentInformacao.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports